// Autocomplete input backed by a <datalist>.
// Behaves like a normal text field but suggests values as you type.
// Still allows free text — operators can type new growers/vehicles not in the list.

interface ComboFieldProps {
  id: string
  /** Field label. Omit (or '') for a bare input — e.g. a compact per-line field. */
  label?: string
  value: string
  onChange: (val: string) => void
  options: string[]
  placeholder?: string
  required?: boolean
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
  /** Override the input class (e.g. 'field text-sm' for a dense form). Defaults to 'field'. */
  inputClassName?: string
}

export default function ComboField({
  id, label, value, onChange, options, placeholder, required, inputMode,
  inputClassName = 'field',
}: ComboFieldProps) {
  const listId = `${id}-list`

  return (
    <div>
      {label && (
        <label htmlFor={id} className="label">
          {label}{required && <span className="text-red-400 ml-0.5">*</span>}
        </label>
      )}
      <input
        id={id}
        list={listId}
        className={inputClassName}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        inputMode={inputMode}
        autoComplete="off"
      />
      {/* ⚠️ Investigated under SPRAY-FERT-UX-AUDIT SF-09 and deliberately left
          alone — recorded here so the next pass does not chase it again.
          The suggestion list is drawn by the BROWSER, so no CSS ancestor can
          clip it: it is NOT the cause of any drop-down being cut off. What is
          true is that it has no visible affordance on Android, iOS renders it
          differently, and the OS truncates long past entries. The audit's own
          verdict was "no change needed for the clipping complaint"; if the
          suggestions ever need to be reliable, they become tappable chips
          under the field rather than a datalist. */}
      <datalist id={listId}>
        {options.map(opt => (
          <option key={opt} value={opt} />
        ))}
      </datalist>
    </div>
  )
}
